module.exports = __webpack_public_path__ + "static/img/trrafic-leisure-icon.55245e62.svg";